// frontend/src/components/admin/AdminRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import AdminLayout from './AdminLayout';

const AdminRoute = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return <div>Cargando...</div>;
    }

    if (!user || user.role !== 'ADMIN') {
        return <Navigate to="/login" replace />;
    }

    return <AdminLayout>{children}</AdminLayout>;
};

export default AdminRoute;